module.exports = __webpack_public_path__ + "static/img/flamingos-rule.df11f11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flamingos-rule.svg
// module id = CD8b
// module chunks = 1